export default __webpack_public_path__ + "static/media/Louise 9781846164590.bc2c1b70.jpg";